import { useAuth } from '@/composables/useAuth';

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) {
    return;
  }

  // クエリ／ハッシュだけの変更はページ遷移ではない（初回描画も同一パスなので除外）
  if (!useNuxtApp().isHydrating && to.path === from.path) {
    return;
  }

  if (useAuth().currentUser.value) {
    useAccessLog().postAccessLog(to);
  }
})
